import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store/configureStore";
import { Button } from "semantic-ui-react";
import { Internship } from "./types";
import InternshipApplicationModal from "./InternshipApplicationModal";
import InitialReflectionModal from "../reflections/InitialReflectionModal";
import AgreementMissingModal from "../shadowings/components/AgreementMissingModal";

interface Props {
  internship: Internship;
  onSuccess?: () => void;
}

const InternshipApplyAction = ({ internship, onSuccess }: Props) => {
  const { t } = useTranslation();
  const [applicationInProgress, setApplicationInProgress] = useState(false);

  const needToFillReflection = useSelector((state: RootState) => !!state.currentUser.needToFillReflection);
  const hasAgreementApproved = useSelector((state: RootState) => !!state.currentUser.seasonInfo?.agreementApproved);

  if (!hasAgreementApproved) {
    return <AgreementMissingModal />;
  }

  const button = (
    <Button content={t("shadowing.actions.applicate")} primary onClick={() => setApplicationInProgress(true)} />
  );

  if (!applicationInProgress) {
    return button;
  }

  if (needToFillReflection) {
    return (
      <>
        {button}
        <InitialReflectionModal onCancel={() => setApplicationInProgress(false)} />;
      </>
    );
  }

  return (
    <>
      {button}
      <InternshipApplicationModal
        internship={internship}
        onCancel={() => setApplicationInProgress(false)}
        onSuccess={onSuccess}
      />
      ;
    </>
  );
};

export default InternshipApplyAction;
